(ns teamoesterreich.admin-mode.lebensretter.detail.device-part
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.cljs-time-utils :refer [cljs-time-utils]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            ))

(defn date-conv [date]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8)
         )
    ""
    ))



(defn device-block [type name last-contact version]
  (let [name (if (= type "BROWSER") "" name)
        version (if (= type "BROWSER") "aktuell" version)]
    [mui/grid
     {:container false
      :item true
      :key (str "device_" name)
      :lg 6
      :xs 12

      }
     [mui/card
      {:variant "outlined"}
      [mui/card-content {}
       [:h4 type " - " name]
       [:div
        "Letzter Kontakt: " (date-conv last-contact)
        [:div {:style {:display "inline_block" :float "right" :width "300px"}} "Version: " version " "] ]
       ]

      ;[mui/card-actions
      ; [mui/button {:size "small" :color "secondary"
      ;              :endIcon (r/as-element [delete-forever])
      ;              } "Löschen"] ]


      ]
     ]
    ))